import { Observable } from 'rxjs';

import {
  makeStateKey,
  StateKey,
  TransferState
} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AssetLoader } from './asset.loader';
import { Injectable } from '@angular/core';

@Injectable()
export class AssetBrowserLoader extends AssetLoader {
  constructor(private readonly http: HttpClient, private readonly transferState: TransferState) {
    super();
  }

  public load(url: string): Observable<any> {
    const key: StateKey<any> = makeStateKey<any>(url);

    const data = this.transferState.get(key, null);

    // First we are looking for the translations in transfer-state, 
	  // if none found, http load as fallback
    if (data) {
      return new Observable((observer) => {
        observer.next(data);
        observer.complete();
      });
    }
    else {
      const headers = new HttpHeaders({
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        'Pragma': 'no-cache',
        'Expires': '0'
      });

      return this.http.get<any>(url, { headers: headers });
    }
  }
}

export function assetBrowserLoaderFactory(
  httpClient: HttpClient,
  transferState: TransferState
) {
  return new AssetBrowserLoader(httpClient, transferState);
}
